
import { usePanelStore } from "@/stores/panelStore";
import { defineComponent } from "vue";
export default defineComponent({
	setup() {
		const panelStore = usePanelStore();
		return { panelStore };
	},
	name: "DefaultComponent",
	mounted() {
		this.$nextTick(() => {
			this.$el.style.background = this.componentState.color || "#f1f1f1";
			this.$el.style.border = "solid 1px #eaeaea";
		});
	},
	props: {
		componentState: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	computed: {
		panelLayout() {
			return this.panelStore.panelLayout;
		}
	},
	watch: {
		componentState: {
			deep: true,
			handler(v: ComponentStateType) {
				this.$nextTick(() => {
					this.$el.style.background = v.color || "#f1f1f1";
				});
			}
		}
	}
});
